export default __webpack_public_path__ + "static/gallery03-ba303f4c4c7e5fce04f2b69464523014.png";